module.exports = __webpack_public_path__ + "img/7.d5493d32.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":571,"height":327,"variants":[{"file":"img/7-480w.ccee88cbac2c.webp","width":480},{"file":"img/7-571w.3951c2178db3.webp","width":571}]};
}